module.exports = __webpack_public_path__ + "static/media/icon-dots.5aa292bd.svg";